import { IContentSource } from "../../domain/file";

export class DownloadSource implements IContentSource {
  constructor(private _getToken: () => string,  private _folderGuid: string, private _fileId: string) {
  }

  get token(): string {
    return this._getToken();
  }

  get source(): string {
    return "/api/folder/" + this._folderGuid + "/file/" + this._fileId + "/download?token=" + this.token;
  }
}
